import { useSearchQuery } from 'src/hooks/useSearchQuery'

export interface IUseRouterGlobalSearchSearchQuery {
  globalSearch?: {
    query?: string
  }
}

export const useRouterGlobalSearch = () => {
  const search = useSearchQuery<IUseRouterGlobalSearchSearchQuery>()

  const open = (
    params: IUseRouterGlobalSearchSearchQuery['globalSearch'] | void
  ) => {
    search.setQuery({
      globalSearch: {
        query: '',
        ...params,
      },
    })
  }

  const close = () => {
    search.setQuery({
      globalSearch: undefined,
    })
  }

  return {
    search,
    ...search.query.globalSearch,
    isOpen: Boolean(search.query.globalSearch),
    close,
    open,
  }
}
